import { NetworkPrinterAdapter } from '@/features/print/adapters/NetworkPrinterAdapter'
import { SunmiPrinterAdapter } from '@/features/print/adapters/SunmiPrinterAdapter'
import { PrinterAdapter } from '@/features/print/adapters/types'
import { ConnectionType } from '@/features/print/constants'
import { AnyConnectionOptions } from '@/features/print/types'

export function createPrinterAdapter(options: AnyConnectionOptions): PrinterAdapter {
    switch (options.type) {
        case ConnectionType.Network:
            return new NetworkPrinterAdapter(options)
        case ConnectionType.SunmiDefault:
            return new SunmiPrinterAdapter()
        default:
            throw new Error(`Unsupported printer connection type: ${(options as any).type}`)
    }
}
